/**
 * Leva o navegador à tela de aprovação do Serpro.
 *
 * Função própria só para os testes poderem trocá-la: o jsdom não navega, e
 * `window.location` não é redefinível sem gambiarra. É navegação de página
 * inteira, e não `useNavigate`, porque o destino é OUTRO site — o médico só
 * volta para cá quando o Serpro o redireciona para `ROTAS.perfilSerproId`.
 */
export function irParaOSerpro(url: string): void {
  window.location.assign(url);
}
